export enum TextSize {
  XXXSMALL = 'xxxsmall',
  XXSMALL = 'xxsmall',
  XSMALL = 'xsmall',
  SMALL = 'small',
  MARKETING_SMALL = 'marketing_small',
  MID = 'mid',
  LARGE = 'large',
  XLARGE = 'xlarge',
  XXLARGE = 'xxlarge',
  XXXLARGE = 'xxxlarge',
  MARKETING_MEGA = 'marketing_mega',
  MARKETING_XMEGA = 'marketing_xmega',
  INHERIT = 'inherit',

  // New Font Sizes
  // Title
  TITLE_90 = 'title-90',
  TITLE_60 = 'title-60',
  TITLE_50 = 'title-50',
  TITLE_40 = 'title-40',
  TITLE_32 = 'title-32',
  TITLE_24 = 'title-24',
  TITLE_20 = 'title-20',
  TITLE_16 = 'title-16',

  // SubTitle
  SUBTITLE_24 = 'subtitle-24',
  SUBTITLE_20 = 'subtitle-20',
  SUBTITLE_16 = 'subtitle-16',

  // Body
  BODY_24 = 'body-24',
  BODY_20 = 'body-20',
  BODY_16 = 'body-16',
  BODY_12 = 'body-12',

  // Button
  BUTTON_24 = 'button-24',
  BUTTON_20 = 'button-20',
  BUTTON_16 = 'button-16',
  BUTTON_12 = 'button-12',

  // Link
  LINK_20 = 'link-20',
  LINK_16 = 'link-16',
  LINK_12 = 'link-12',
}

export enum FontWeight {
  BLACK = 'black',
  BOLD = 'bold',
  MEDIUM = 'medium',
  NORMAL = 'normal',
  LIGHT = 'light',
  INHERIT = 'inherit',
}

export enum FontStyle {
  INHERIT = 'inherit',
  ITALIC = 'italic',
  NORMAL = 'normal',
}

export enum TextAlign {
  CENTER = 'center',
  LEFT = 'left',
  RIGHT = 'right',
}

export enum TextVerticalAlign {
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
  BASELINE = 'baseline',
}

export enum TextTransform {
  CAPITALIZE = 'capitalize',
  LOWERCASE = 'lowercase',
  UPPERCASE = 'uppercase',
  INHERIT = 'inherit',
}

export enum ReadMore {
  LINK = 'link',
  PLAIN_LINK = 'plain_link',
  NONE = 'none',
}

export enum ReadMoreColor {
  LIGHT = 'light',
  INHERIT = 'inherit',
}

export enum FontColor {
  INHERIT = 'inherit',
  FOREGROUND = 'foreground',
  DARK = 'dark',
  LIGHT = 'light',
  PRIMARY = 'primary',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

export enum PlaceholderColor {
  INHERIT = 'inherit',
  LIGHT = 'light',
}
